var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.625,
    height: 51.709,
    viewBox: "0 0 63.625 51.709",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path3611",
    d: "M560.189,621.567c24.011,0,37.141-19.892,37.141-37.141q0-.848-.037-1.687a26.542,26.542,0,0,0,6.511-6.76,26.027,26.027,0,0,1-7.5,2.055,13.1,13.1,0,0,0,5.74-7.22,26.176,26.176,0,0,1-8.289,3.169,13.065,13.065,0,0,0-22.245,11.9,37.063,37.063,0,0,1-26.907-13.639,13.065,13.065,0,0,0,4.042,17.427,12.958,12.958,0,0,1-5.912-1.633c0,.055,0,.108,0,.167a13.057,13.057,0,0,0,10.473,12.8,13.032,13.032,0,0,1-5.9.224,13.067,13.067,0,0,0,12.195,9.067,26.188,26.188,0,0,1-16.213,5.588,26.526,26.526,0,0,1-3.114-.181,36.952,36.952,0,0,0,20.01,5.864",
    transform: "translate(-540.179 -569.858)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.929853a42d025194109d037b103ce2bd.svg";
export { ForwardRef as ReactComponent };